<template>
	<div data-component="body-blocks" :class="`-variant-${normalizedVariant}`">
		<div class="content">
			<SanityContent :value="content" :components="portableComponents" />
		</div>
	</div>
</template>

<script setup>
import { createBodyPortableComponents } from './portableComponents'

const props = defineProps({
	content: { type: Array, default: undefined },
	variant: { type: String, default: 'article' },
	portableTypeOverrides: { type: Object, default: () => ({}) },
})

const normalizedVariant = computed(() => (props.variant === 'legal' ? 'legal' : 'article'))
const portableComponents = computed(() => createBodyPortableComponents(props.portableTypeOverrides))
</script>

<style lang="scss" scoped>
[data-component='body-blocks'] {
	:deep(.content > p) {
		@include body-big-regular;
		margin: rs(33, 33) 0;
		color: var(--color-neutral-tints-700);

		strong {
			@include body-big-medium;
			color: var(--color-neutral-tints-700);
		}
	}

	:deep(.content > p:has(+ ul)),
	:deep(.content > p:has(+ ol)) {
		margin-bottom: 0;
	}

	:deep(.content > ul),
	:deep(.content > ol) {
		margin: rs(10, 10) 0;
		padding-left: rs(24, 24);

		li {
			@include body-big-regular;
			color: var(--color-neutral-tints-700);

			strong {
				@include body-big-medium;
				color: var(--color-neutral-tints-700);
			}
		}
	}

	:deep(.content > ul) {
		list-style-type: disc;
	}

	:deep(.content > ol) {
		list-style-type: decimal;
	}

	:deep(.content > ul > li::marker),
	:deep(.content > ol > li::marker) {
		color: var(--color-neutral-tints-700);
	}

	:deep(.content a) {
		@include inherit-font;
		color: var(--color-river-blue-500);
		text-decoration: underline;
	}

	&.-variant-article {
		:deep(.content > h2),
		:deep(.content > h3) {
			@include headline-1;
			margin-top: rs(64, 64);
			margin-bottom: rs(33, 33);
			color: var(--color-river-blue-900);
		}
	}

	&.-variant-legal {
		:deep(.content > h2),
		:deep(.content > h3) {
			@include headline-1;
			margin-top: rs(64, 64);
			margin-bottom: rs(33, 33);
			color: var(--color-neutral-tints-700);
		}

		:deep(.content ol li),
		:deep(.content ul li) {
			@include body-big-regular;
			color: var(--color-neutral-tints-700);

			strong {
				@include body-big-medium;
				color: var(--color-neutral-tints-700);
			}
		}
	}
}
</style>
